import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=0f47820e&scoped=true"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"
import style0 from "./Groups.vue?vue&type=style&index=0&id=0f47820e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f47820e",
  null
  
)

export default component.exports